

















import Dialog from '@/components/common/Dialog.vue';
import {noop} from 'lodash-es';
import {Component, Vue} from 'vue-property-decorator';

@Component({components: {Dialog}})
export default class NotSubmittedDataDialog extends Vue {
    private resolve: (save: boolean) => void;

    private get dialog(): Dialog {
        return this.$refs.dialog as Dialog;
    }

    public show(): Promise<boolean> {
        this.dialog.show();

        return new Promise<boolean>(resolve => this.resolve = resolve)
            .finally(() => this.resolve = noop);
    }
}
